import { render, staticRenderFns } from "./CameraAudioChoose.vue?vue&type=template&id=3b188a96&"
import script from "./CameraAudioChoose.vue?vue&type=script&lang=js&"
export * from "./CameraAudioChoose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports